import { render } from "./LeaveDocumentViewer.vue?vue&type=template&id=52df2e97"
import script from "./LeaveDocumentViewer.vue?vue&type=script&lang=js"
export * from "./LeaveDocumentViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__